export const routerPath = {
  root: '/Users',
};

export const getColumns = ({ editItem, deleteItem }) => [
  {
    id: 'iconId',
    type: 'avatar',
    label: 'Avatar',
    align: 'center',
    disableSort: 'true',
  },
  { id: 'name', label: 'Name', align: 'left' },
  { id: 'surname', label: 'Surname', align: 'left' },
  { id: 'email', label: 'Email', align: 'center' },
  { id: 'region', label: 'Region', align: 'center', disableSort: true },
  { id: 'facilityRegion', label: 'Facility Region', align: 'center', disableSort: true },
  { id: 'facilityName', label: 'Facility', align: 'center', disableSort: true },
  { id: 'vendorName', label: 'Vendor', align: 'center', disableSort: true },
  { id: 'challengeName', label: 'Challenge', align: 'center', disableSort: true },
  { id: 'role', label: 'Role', align: 'center' },
  {
    id: 'more-menu',
    type: 'menu',
    items: [
      {
        id: 'delete',
        name: 'Delete',
        action: deleteItem,
        icon: 'eva:trash-2-outline',
        sx: { color: 'error.main' },
      },
      { id: 'edit', name: 'Edit', action: editItem, icon: 'eva:edit-fill' },
    ],
    disableSort: true,
  },
];

export const getFilters = ({ facility, searchByName, options }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Search by name, surname...',
    action: searchByName.change,
  },
  {
    id: 'facility',
    type: 'select',
    label: 'Facility',
    value: facility.value,
    action: facility.change,
    items: options?.facilities?.length ? ['all', ...options.facilities] : ['all'],
  },
];
